import {
  MAX_PAYLOAD_SIZE,
  PUBLIC_VIEW_KEY_LENGTH,
} from './../../constants/encryption';

import {
  CONVERSATION_ID_LENGTH,
  MESSAGE_LENGTH_PREFIX_LENGTH,
  SENDER_PROOF_LENGTH,
} from './../../constants/dataFrame';

/**
 * Unpacks a fixed-size message buffer into its original components.
 *
 * Layout:
 * - [0..2)      : message length (2-byte big-endian)
 * - [2..18)     : conversation ID
 * - [18..82)    : sender proof (64 bytes)
 * - [82..114)   : sender next view public key (32 bytes)
 * - [114..146)  : sender current view public key (32 bytes)
 * - [146..146+length) : message content (UTF-8)
 */
export function parseDataFrame(buffer: Uint8Array): {
  conversationId: Uint8Array;
  senderProof: Uint8Array;
  senderNextViewPublicKey: Uint8Array;
  senderViewPublicKey: Uint8Array;
  messageBytes: Uint8Array;
} {
  if (buffer.length !== MAX_PAYLOAD_SIZE) {
    throw new Error(`Invalid buffer size: expected ${MAX_PAYLOAD_SIZE}, got ${buffer.length}`);
  }

  const length = (buffer[0] << 8) | buffer[1];

  const offsetConversationId = MESSAGE_LENGTH_PREFIX_LENGTH; // 2
  const offsetProof = offsetConversationId + CONVERSATION_ID_LENGTH; // 18
  const offsetNextViewKey = offsetProof + SENDER_PROOF_LENGTH; // 50
  const offsetViewKey = offsetNextViewKey + PUBLIC_VIEW_KEY_LENGTH; // 82
  const offsetMessage = offsetViewKey + PUBLIC_VIEW_KEY_LENGTH; // 114

  const conversationId = buffer.slice(offsetConversationId, offsetProof);
  const senderProof = buffer.slice(offsetProof, offsetNextViewKey);
  const senderNextViewPublicKey = buffer.slice(offsetNextViewKey, offsetViewKey);
  const senderViewPublicKey = buffer.slice(offsetViewKey, offsetMessage);
  const messageBytes = buffer.slice(offsetMessage, offsetMessage + length);

  return {
    conversationId,
    senderProof,
    senderNextViewPublicKey,
    senderViewPublicKey,
    messageBytes,
  };
}